var SupportDropDownCombinationsModel, SupportDropDownModel, SupportInbentaModel;

SupportDropDownModel = require('./dropdowns');

SupportDropDownCombinationsModel = require('./dropdown_combinations');

SupportInbentaModel = (function() {
  function SupportInbentaModel() {
    this.init(null);
    this.dropDowns = new SupportDropDownModel();
    this.dropDownCombinations = new SupportDropDownCombinationsModel();
  }

  SupportInbentaModel.prototype.init = function(currentOrder) {
    this.isCurrentOrderSelected = currentOrder ? true : false;
    window.Groupon.Support.Inbenta = {};
    this.flexibleStepThree = null;
    this.displayStatus = null;
    this.displayNotes = null;
    this.externalDealNotes = null;
    return this.isCostcoDropdownCombination = false;
  };

  SupportInbentaModel.prototype.getCategory = function() {
    return Groupon.Support.Inbenta.Category;
  };

  SupportInbentaModel.prototype.getSubCategory = function() {
    return Groupon.Support.Inbenta.SubCategory;
  };

  SupportInbentaModel.prototype.getSearchInputIssue = function() {
    return Groupon.Support.Inbenta.searchInputIssue;
  };

  SupportInbentaModel.prototype.getContentId = function() {
    return Groupon.Support.Inbenta.ContentId;
  };

  SupportInbentaModel.prototype.setSubCategory = function(subCategory) {
    return Groupon.Support.Inbenta.SubCategory = subCategory;
  };

  SupportInbentaModel.prototype.setCategory = function(category) {
    return Groupon.Support.Inbenta.Category = category;
  };

  SupportInbentaModel.prototype.setContentId = function(contentId) {
    return Groupon.Support.Inbenta.ContentId = contentId;
  };

  SupportInbentaModel.prototype.setSearchInputIssue = function(searchInputIssue) {
    return Groupon.Support.Inbenta.searchInputIssue = searchInputIssue;
  };

  SupportInbentaModel.prototype.onUnloadStepOne = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      return $.event.trigger('inbenta-help-wizard-step1-completed');
    }
  };

  SupportInbentaModel.prototype.onInitStepTwo = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      return $.event.trigger('initiate-inbenta-help-wizard-step2');
    }
  };

  SupportInbentaModel.prototype.onInitStepThree = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      return $.event.trigger('initiate-inbenta-help-wizard-step3');
    } else if (window.shouldShowOptimizedChannel() || window.shouldShowFlexibleChannel()) {
      return $.event.trigger('inbenta-hash-change', ['#contact-us', '#contact-us']);
    }
  };

  SupportInbentaModel.prototype.extendParams = function(params) {
    return _.extend(Groupon.Support.Inbenta, params);
  };

  return SupportInbentaModel;

})();

module.exports = SupportInbentaModel;

//# sourceMappingURL=data:application/json;base64,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
